var SupportDropDownCombinationsModel, SupportDropDownModel, SupportInbentaModel;

SupportDropDownModel = require('./dropdowns');

SupportDropDownCombinationsModel = require('./dropdown_combinations');

SupportInbentaModel = (function() {
  function SupportInbentaModel() {
    this.init(null);
    this.dropDowns = new SupportDropDownModel();
    this.dropDownCombinations = new SupportDropDownCombinationsModel();
  }

  SupportInbentaModel.prototype.init = function(currentOrder) {
    this.isCurrentOrderSelected = currentOrder ? true : false;
    window.Groupon.Support.Inbenta = {};
    this.flexibleStepThree = null;
    this.displayStatus = null;
    this.displayNotes = null;
    this.externalDealNotes = null;
    return this.isCostcoDropdownCombination = false;
  };

  SupportInbentaModel.prototype.getCategory = function() {
    return Groupon.Support.Inbenta.Category;
  };

  SupportInbentaModel.prototype.getSubCategory = function() {
    return Groupon.Support.Inbenta.SubCategory;
  };

  SupportInbentaModel.prototype.getSearchInputIssue = function() {
    return Groupon.Support.Inbenta.searchInputIssue;
  };

  SupportInbentaModel.prototype.getContentId = function() {
    return Groupon.Support.Inbenta.ContentId;
  };

  SupportInbentaModel.prototype.setSubCategory = function(subCategory) {
    return Groupon.Support.Inbenta.SubCategory = subCategory;
  };

  SupportInbentaModel.prototype.setCategory = function(category) {
    return Groupon.Support.Inbenta.Category = category;
  };

  SupportInbentaModel.prototype.setContentId = function(contentId) {
    return Groupon.Support.Inbenta.ContentId = contentId;
  };

  SupportInbentaModel.prototype.setSearchInputIssue = function(searchInputIssue) {
    return Groupon.Support.Inbenta.searchInputIssue = searchInputIssue;
  };

  SupportInbentaModel.prototype.onUnloadStepOne = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      return $.event.trigger('inbenta-help-wizard-step1-completed');
    }
  };

  SupportInbentaModel.prototype.onInitStepTwo = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      return $.event.trigger('initiate-inbenta-help-wizard-step2');
    }
  };

  SupportInbentaModel.prototype.onInitStepThree = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      return $.event.trigger('initiate-inbenta-help-wizard-step3');
    } else if (window.shouldShowOptimizedChannel() || window.shouldShowFlexibleChannel()) {
      return $.event.trigger('inbenta-hash-change', ['#contact-us', '#contact-us']);
    }
  };

  SupportInbentaModel.prototype.extendParams = function(params) {
    return _.extend(Groupon.Support.Inbenta, params);
  };

  return SupportInbentaModel;

})();

module.exports = SupportInbentaModel;

//# sourceMappingURL=data:application/json;base64,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
